var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mostlikes-data',{attrs:{"title":"Most Like Titles"}}),_c('nanogenres-data'),_c('minigenres-data'),_c('genres-data')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }